import Client from "@/http/client";
import {
  SupportHotelDetailDto,
  SupportHotelFilterParams,
  SupportHotelListDto,
} from "@/http/dto/supportHotel";

export class SupportHotels {
  static async getHotels(params: SupportHotelFilterParams) {
    return await Client.get<SupportHotelListDto>("/v2/supporter/hotels", params);
  }

  static async getHotel(hotelObjectId: string) {
    return await Client.get<SupportHotelDetailDto>(`/v2/supporter/hotels/${hotelObjectId}`);
  }
}
